<script setup lang="ts">
    import { onMounted, ref, computed, watch } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useQuoteJourneyModelStore } from './stores/quoteJourneyModel'
    import { useRiskDataStore } from './stores/riskData'
    import { useRoute } from 'vue-router'

    import Steps from './components/Steps.vue'
    import MyPolicyTest from './components/shared/modals/MyPolicyTest.vue'

    const quoteJourneyModelStore = useQuoteJourneyModelStore();
    const riskDataStore = useRiskDataStore();
    const route = useRoute();
    const showSteps = ref(false);

    const isQuoteDisplay = computed(() => {
      return route?.path.includes('quote/quotes') || route?.path.includes('quote/confirmation');
    });

    watch(() => route.path, (newVal, oldVal) => {
        showSteps.value = !route?.path.includes('registration');
    });

    quoteJourneyModelStore.setQuoteJourneyData(dataModel.quoteJourneyModel);
    riskDataStore.setRiskData(
        dataModel.riskData,
        insurerTrades,
        tradesMD,
        businessLegalStatuses,
        manualWorkOptions,
        accountantHighRiskActivities,
        highRiskITActivities,
        highRiskWorkLocations,
    );
</script>

<template>
    <Steps v-if="showSteps" />
    <div v-if="isQuoteDisplay" class="quote-display-background"></div>
    <div class="container px-sm-4">
        <div class="row main-content">
            <RouterView v-slot="{ Component }">
              <Transition name="fade-slide" mode="out-in">
                <Component :is="Component" />
              </Transition>
            </RouterView>
        </div>
    </div>

    <MyPolicyTest />
</template>
   
